import React from 'react';
import { connect } from 'react-redux';
import { IonContent, IonFooter, useIonViewWillLeave } from '@ionic/react';

import intl from '$intl';
import { screen } from '$fcomponents/hoc';
import { Div, SPACE } from '$gstyles';
import { Form, Formik } from 'formik';
import { FormSection } from '$gcomponents/reusables';
import { Button } from '$gcomponents/primitives';
import { input } from '$gbusiness/helpers';
import { Flex } from '$gstyles/wrapper';
import Header from '$components/header';
import { factoryActions } from '$fbusiness/redux/factory';
import FactoryModel from '$fbusiness/models/factory';
import PATH from '$business/enums/paths';
import { initActions } from '$business/redux/init';
import { IonPageWrapper } from '../factoryDetailsScreen/styles';

import ECOMMERCE_SETTINGS_FORM from './ecommerceSettingsForm';

interface EcommerceSettingsScreenProps {
  history: any;
  myFactory: FactoryModel;
  saveFactory: Function;
  fetchMyFactory: Function;
}

const EcommerceSettingsScreen: React.FC<EcommerceSettingsScreenProps> = ({
  history,
  saveFactory,
  myFactory: factory,
  fetchMyFactory,
}) => {
  useIonViewWillLeave(() => {});

  if (!factory) return <IonPageWrapper />;

  const { ecommerce, factoryId } = factory;

  const onSubmit = async (values: any) => {
    await saveFactory(factoryId, values);
    await fetchMyFactory();
  };

  const closeScreen = () => {
    history.push(PATH.SETTINGS);
  };

  const ecommerceSettingsForm = ECOMMERCE_SETTINGS_FORM();

  const validateForm = (values: any) => {
    return input.validateError(ecommerceSettingsForm, values);
  };

  const initialValues = {
    ecommerce: {
      aznet: {
        aznet1: ecommerce?.aznet?.aznet1 || '',
        aznet2: ecommerce?.aznet?.aznet2 || '',
      },
    },
  };

  return (
    <IonPageWrapper>
      <Header titleText={intl('SCREEN.ECOMMERCE.TITLE_SETTINGS')} />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validate={validateForm}
        onSubmit={(values) => {
          onSubmit(values);
        }}>
        {(formik) => (
          <>
            <IonContent>
              <Div padding={SPACE.LARGE} maxWidth="800px">
                <Form>
                  <FormSection FORM={ecommerceSettingsForm} formik={formik} />
                </Form>
              </Div>
            </IonContent>
            <IonFooter>
              <Flex padding={SPACE.MEDIUM} justifyContent="space-between">
                <Button variant="outlined" onClick={closeScreen}>
                  {intl('BUTTON.CANCEL')}
                </Button>
                <Button
                  disabled={!formik.isValid || !formik.dirty}
                  color="primary"
                  className="submit-button"
                  variant="contained"
                  onClick={formik.handleSubmit}>
                  {intl('BUTTON.SUBMIT')}
                </Button>
              </Flex>
            </IonFooter>
          </>
        )}
      </Formik>
    </IonPageWrapper>
  );
};

const mapStateToProps = (state: any) => ({
  myFactory: state.factory.factory,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  onHydrate: () => factoryActions.fetchMyFactory(),
  onDehydrate: factoryActions.dehydrate,
  fetchMyFactory: () => initActions.fetchMyFactory(true),
  saveFactory: factoryActions.saveFactory,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(EcommerceSettingsScreen));
